import { FC } from 'react';
import { observer } from 'mobx-react';
import { useDependencies } from '@servicetitan/react-ioc';
import { FeatureFlags } from '../../common/models/feature-flags';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { GlobalSearchMFE } from './global-search-mfe';
import { EHStore } from '../../common/stores/eh.store';

export const GlobalSearch: FC = observer(() => {
    const [{ isAdmin }] = useDependencies(EHStore);

    const { globalSearchIsMfeEnabled } = useFlags<FeatureFlags>();

    if (isAdmin || !globalSearchIsMfeEnabled) {
        return null;
    }

    return <GlobalSearchMFE />;
});
